import axios from 'axios';
import { hasAuthAccessParams } from '../types/guards';
import { processResponse, processError, privateRequestParams } from '../utils';
export default class HeroSupportAPI {
    static sendTicket(accessParams, subject, message) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/intercom/create-ticket/', { subject, message }, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
}
//# sourceMappingURL=index.js.map